import React from 'react';
import Header from './Header';
import Footer from './Footer';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <>
      {/* Background - matching WeatherApp exactly */}
      <div className="fixed inset-0 bg-[#0D1421] z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900/50 via-purple-900/30 to-slate-900/50"></div>
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(59,130,246,0.12),transparent_50%)]"></div>
      </div>

      <div className="relative z-10 min-h-screen flex flex-col">
        <Header />
        
        <main className="flex-1">
          {/* Container wrapper - samma som WeatherApp men pb-24 för att ge plats åt FishingNavigation */}
          <div className="px-3 sm:px-4 md:px-6 lg:px-8 pb-24 pt-4 sm:pt-6">
            <div className="mx-auto max-w-7xl">
              {children}
            </div>
          </div>
        </main>
        
        <Footer />
      </div>
    </>
  );
};
